import { render, staticRenderFns } from "./PhoneNumberInput.vue?vue&type=template&id=10b3fb8c"
import script from "./PhoneNumberInput.vue?vue&type=script&lang=js"
export * from "./PhoneNumberInput.vue?vue&type=script&lang=js"
import style0 from "./PhoneNumberInput.vue?vue&type=style&index=0&id=10b3fb8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports